import React, { useEffect, useState } from 'react';
import { Alert } from 'antd';
import { isInstallerNativeApp } from '../utils/installerSms';

const InstallerOfflineBanner = () => {
    const [offline, setOffline] = useState(
        typeof navigator !== 'undefined'
            ? !navigator.onLine
            : false
    );

    useEffect(() => {
        if (!isInstallerNativeApp()) return undefined;

        const onOff = () => setOffline(true);
        const onOn = () => setOffline(false);
        window.addEventListener('offline', onOff);
        window.addEventListener('online', onOn);
        setOffline(!navigator.onLine);

        return () => {
            window.removeEventListener('offline', onOff);
            window.removeEventListener('online', onOn);
        };
    }, []);

    if (!isInstallerNativeApp() || !offline) {
        return null;
    }

    return (
        <Alert
            type="warning"
            showIcon
            style={{ margin: '0 0 10px' }}
            message="Нет интернета"
            description="Заявки берутся из кэша. Передача ТМЦ и отчёты встают в очередь и уйдут, когда появится сеть. Очередь нельзя очистить, пока записи не отправятся."
        />
    );
};

export default InstallerOfflineBanner;
